<script>
	const model = require('model/model');

	const accountSettingsUtilities = require('utilities/accountSettingsUtilities');
	const getAccountSetting = accountSettingsUtilities.read;
	const updateAccountSetting = accountSettingsUtilities.update;

	const routeMatch = (route, path) => (route === '/' && path === '/') || (route !== '/' && path.indexOf(route) === 0) || route === 'ALL_ROUTES';
	const pathRestricted = path => path?.includes('onboarding');

	module.exports = {
		props: ['routeContext'],
		components: {
			'outbound-link': require('components/outbound-link.vue').default
		},
		modelData: ['bannerNotification', 'userContext'],
		data() {
			return {
				notification: null,
				removeNotification: false,
				dismissed: true
			};
		},
		computed: {
			body() {
				let notification = this.notification;
				return notification ? notification.body : null;
			},
			bodyIs() {
				let notification = this.notification;
				return notification && notification.bodyIs ? notification.bodyIs : null;
			},
			link() {
				let notification = this.notification;
				return notification ? notification.link : null;
			},
			isExternalLink() {
				return this.link.includes('http');
			},
			dismissOnClick() {
				let notification = this.notification;
				return notification ? notification.dismissOnClick : null;
			},
			dismissOnLinkClick() {
				let notification = this.notification;
				return notification ? notification.dismissOnLinkClick : false;
			}
		},
		watch: {
			bannerNotification(notif) {
				if (notif && notif.dismissKey) {
					this.getDimissKey(notif.dismissKey);
				}
			},
			routeContext(value, oldValue) {
				if (value.path !== oldValue.path) {
					this.handleBannerDisplay();
				}
			}
		},
		methods: {
			flagNotificationForRemoval() {
				this.removeNotification = true;
			},
			checkIfNotificationShouldBeRemoved() {
				if (this.removeNotification) {
					this.close();
				}
			},
			onBannerClick() {
				if (this.dismissOnClick) {
					this.close();
				}
			},
			clearNotification() {
				model.remove('bannerNotification');
				this.removeNotification = false;
				this.notification = null;
			},
			close() {
				let notification = this.notification;
				this.clearNotification();

				if (notification && notification.dismissKey) {
					this.dismissed = true;
					this.updateDimissKey(notification.dismissKey);
				}
			},
			getDimissKey(key) {
				return getAccountSetting(key)
					.then(value => {
						if (value) {
							let notif = model.get('bannerNotification');

							//Ensure same notif is set now
							if (notif && notif.dismissKey === key) {
								this.clearNotification();
							}
							// banner has not been dismissed
						} else {
							this.setNotification();
							this.handleBannerDisplay();
						}
					})
					.done();
			},
			updateDimissKey(key) {
				return updateAccountSetting(key, true).done();
			},
			onLinkClick() {
				if (this.dismissOnLinkClick) {
					this.close();
				}
			},
			setNotification() {
				this.notification = this.bannerNotification;
			},
			handleBannerDisplay() {
				let path = this.routeContext.path;
				let notification = this.notification;
				let route = notification ? notification.route : null;
				let routes = notification ? notification.routes : null;
				let once = notification ? notification.once : null;

				let pathMatch = false;
				if (path && route) {
					pathMatch = routeMatch(route, path);
				}
				if (!pathMatch && path && routes) {
					pathMatch = routes.some(r => routeMatch(r, path));
				}
				// display banner logic
				if (!pathRestricted(path) && pathMatch) {
					if (path && route && once) {
						this.flagNotificationForRemoval();
					}
					this.dismissed = false;
				} else {
					this.dismissed = true;
				}

				if (!pathMatch) {
					this.checkIfNotificationShouldBeRemoved();
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.notification-bar {
		background-color: $c-blue-notif;
		color: $c-blue-dark;

		a {
			text-decoration: underline;

			&,
			&:hover,
			&:focus {
				color: $c-blue-dark;
			}
		}

		.wrapper {
			position: relative;
			padding: 1rem 1rem 1rem 0;
			display: flex;
			justify-content: space-between;

			&.banner-link {
				> a {
					display: block;
					text-decoration: none;

					&:hover {
						text-decoration: underline;
					}
				}
			}

			> :first-child {
				flex: 1;
			}
		}

		.close-icon {
			color: $c-blue-dark;
			margin-left: 1rem;
			line-height: 8px;
			cursor: pointer;

			&:hover {
				color: $c-blue;
			}
		}

		.call-to-action {
			color: $c-blue-dark;
			text-decoration: underline;
		}

		.call-to-action-link {
			color: $c-slate-dark;
			text-decoration: underline;

			&:hover {
				color: $c-slate-dark;
				text-decoration: none;
			}
		}

		&:hover .call-to-action {
			color: $c-slate-dark;
			text-decoration: none;
		}
	}
</style>
<template>
	<div
		class="notification-bar"
		role="status"
		v-show="notification && (body || bodyIs) && !dismissed">
		<div
			class="wrapper"
			:class="{
				'banner-link': link
			}"
			@click="onBannerClick">
			<component
				v-if="bodyIs"
				:is="bodyIs"></component>
			<template v-else>
				<template v-if="link">
					<outbound-link
						v-if="isExternalLink"
						:href="link"
						target="_blank"
						data-outbound-link="NOTIFICATION_BAR_LINK"
						@click="onLinkClick">
						<span v-html="body"></span>
					</outbound-link>
					<a
						v-else
						:href="link"
						v-html="body"
						@click="onLinkClick"></a>
				</template>
				<span
					v-else
					v-html="body"></span>
			</template>
			<div v-if="userContext">
				<button
					class="button -link close-icon"
					@click.stop="close"
					aria-label="Dismiss message">
					<i
						class="fa-solid fa-circle-xmark"
						aria-hidden="true"></i>
				</button>
			</div>
		</div>
	</div>
</template>
